import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import InfoDrawer from '../../common/_InfoDrawer.jsx';
import HelpCenterHeader from '../support/_HelpCenterHeader.jsx';
import CrowdNavigation from '../common/_CrowdNavigation.jsx';
import ZoomModal from '../../modals/_ZoomModal.jsx';

import FAQContent from './faqcontent/FAQContent.jsx';


export default class CrowdFAQ extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			faqs: FAQContent()[FAQContent().length - 1].content,
			selectedFAQ: FAQContent()[FAQContent().length - 1].id
		}
	}

	componentDidMount() {
		const guidelineImages = document.querySelectorAll('.crowd-guidelines-image');

		Array.from(guidelineImages).map(item => {
			if(!item.classList.contains('crowd-guidelines-image--no-zoom')) {
				item.addEventListener('click', (img) => {
					const imageUrl = item.querySelector('img').src;
					this.toggleZoomModal(imageUrl);
				});
			}
		});
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={3}/> : null}
				{this.state.clickedImage ? <ZoomModal data={{images: [this.state.clickedImage]}} func={{toggleZoomModal: () => this.toggleZoomModal(false)}}/> : null}
				<HelpCenterHeader title="FAQs"/>
				<div className="main">
					<div className="main__content">
						{this.renderIntro()}
						{this.renderFAQ()}
						{this.renderFooter()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderIntro() {
		return (
			<section className="crowd-faq__intro">
				<h1 className="text--xxl-title text--bold l-margin-bottom text-color--darkestBlue">Frequently Asked Questions</h1>
				<p className="l-margin-bottom">If your question was not answered in our FAQs below, please go to our <a href="https://forum.bricklink.com/viewforum.php?f=13&sid=275872312bdb877b1372a3ec3a8d56d7">Forum</a>. Our team will be checking the Forum regularly to answer questions. We will also continue to update this FAQ page based on popular topics that are brought up in the Forum. </p>
				<p>If you need feedback or have specific questions about your design, please contact <a href="mailto:bdpsupport@lego.com">BDPsupport@lego.com</a>.</p>
			</section>
		);
	}

	renderFooter() {
		return (
			<section className="crowd-faq__footer">
				<h2 className="text--xl-title text--bold l-margin-bottom--xl">Get more information</h2>
				<div className="crowd-faq__footer-content">
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--blue">
							<i className="fa-light fa-fw fa-messages-question"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Still need help? Discuss various topics with the community and BDP team.</p>
							<a href={"https://forum.bricklink.com/viewforum.php?f=13&sid=275872312bdb877b1372a3ec3a8d56d7"} className="text--bold crowd-faq__footer-item-cta">Visit the Forum</a>
						</div>
					</div>
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--yellow">
							<i className="fa-light fa-fw fa-lightbulb-on"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Want to freshen up on your Studio skills or troubleshoot?</p>
							<a href={"https://studiohelp.bricklink.com/hc/en-us"} target="_blank" className="text--bold crowd-faq__footer-item-cta">Tour Studio Help Center<i className="l-margin-left--sm far fa-square-arrow-up-right"/></a>
						</div>
					</div>
					<div className="crowd-faq__footer-item">
						<div className="crowd-faq__footer-item-icon crowd-faq__footer-item-icon--green">
							<i className="fa-light fa-fw fa-envelope"/>
						</div>
						<div className="crowd-faq__footer-item-main">
							<p>Need feedback or have specific questions about your design?</p>
							<a href={"mailto:bdpsupport@lego.com"} className="text--bold crowd-faq__footer-item-cta">Email the BDP Team</a>
						</div>
					</div>
				</div>
			</section>
		);
	}

	expandFAQSection(id) {
		const {faqs} = this.state;
		const groupID = faqs.findIndex(item => item.id == id);

		if(faqs[groupID].allOpen == true) {
			faqs[groupID].allOpen = false;

			faqs[groupID].items.map(item => item.open = false);
		}else{
			faqs[groupID].allOpen = true;

			faqs[groupID].items.map(item => item.open = true);
		}

		this.setState({faqs: faqs});
	}

	renderFAQ() {
		const faqs = this.state.faqs.map((faq, key) => {
			const parentId = faq.id;

			return (
				<section id={faq.title.toLowerCase().replace(/ /g, '-')} className={key != 0 ? 'crowd-help__faq-group' : ''}>
					<header className="l-flex l-split l-margin-bottom">
						<h2 className="text--xl-title text--bold">{faq.title}</h2>
						<button data-ts-name={`faq-expand-collapse-all faq-expand-collapse-all--${faq.title}`} className="btn btn--link" onClick={() => this.expandFAQSection(faq.id)}>{faq.allOpen ? 'Collapse' : 'Expand'} all</button>
					</header>
					{faq.items.map((faq, key) => <InfoDrawer id={faq.urlHash ? faq.urlHash : faq.question.replace(/ /g, '-').replace('?', '').toLowerCase()} isOpen={faq.open} onChangeFunc={() => this.openDrawer(parentId, faq.id)} classes="crowd-help__faq-item" key={key} label={faq.question} icon={'arrow'} bold={true}><p className="l-margin-top--sm" dangerouslySetInnerHTML={{__html: faq.answer}}/></InfoDrawer>)}
				</section>
			);
		});
		
		return (
			<section className="crowd-help__faq-section">
				<section className="crowd-help__split-section crowd-help__split-section--faqs">
					<div className="crowd-help__split-column crowd-help__split-column--left">
						{this.renderFAQNav()}
					</div>
					<div className="crowd-help__split-column crowd-help__split-column--right">
						{faqs}
					</div>
				</section>
			</section>
		);
	}

	renderFAQNav() {
		const links = this.state.faqs.map((faq, key) => 
			<li className={key != 0 ? 'l-margin-top' : ''}>
				<a href={`#${faq.title.toLowerCase().replace(/ /g, '-')}`} data-ts-name="crowd-faq-nav__link">{faq.title}</a>
			</li>
		);

		const options = this.state.faqs.map((faq, key) => 
			<option value={`${faq.title.toLowerCase().replace(/ /g, '-')}`}>{faq.title}</option>
		);

		return (
			<React.Fragment>
				<div className="crowd-help__faq-nav-links">
					<h2 className="text--small-title text--bold l-margin-bottom">Jump to topic</h2>
					<ul data-ts-name="faq-nav-list" className="text--small-title">
						{links}
					</ul>
				</div>
				<div className="crowd-help__faq-nav-dropdown">
					<select data-ts-name="faq-nav-dropdown" className="select l-full-width" onChange={(e) => this.jumpToFAQ(e.target.value)} data-ts-name="crowd-faq-nav__select">
						<option value={this.state.faqs[0].title.toLowerCase().replace(/ /g, '-')}>Jump to topic</option>
						{options}
					</select>
				</div>
			</React.Fragment>
		);
	}

	jumpToFAQ(value) {
		const faqItem = document.querySelectorAll('#' + value)[0];

		window.scrollTo({top: faqItem.offsetTop});
	}

	openDrawer(parentId, itemId) {
		const {faqs} = this.state;
		const parentIdx = faqs.findIndex(item => item.id == parentId);
		const itemIdx = faqs[parentIdx].items.findIndex(item => item.id == itemId);

		faqs[parentIdx].items[itemIdx].open = !faqs[parentIdx].items[itemIdx].open;

		const isAllOpen = faqs[parentIdx].items.filter(item => item.open == true).length == faqs[parentIdx].items.length;

		if(isAllOpen) {
			faqs[parentIdx].allOpen = true;
		}else{
			faqs[parentIdx].allOpen = false;
		}

		this.setState({faqs: faqs});
	}

	toggleZoomModal(url) {
		this.setState({clickedImage: url}, blapp.screen.toggleScroll(!this.state.clickedImage));
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdFAQ blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);
